import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const BrandVocabularyPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "BrandVocabularyPopup" */ './View'),
  'popup'
);
